import Marionette from 'backbone.marionette';
import { BindedView } from 'marionette.binding';
import DialogService from 'base/dialog_service';
import ContactGroup from 'base/models/contactgroup';


const ProcessingView = Marionette.LayoutView.extend({
    template: require('base/templates/contacts/new_group_processing.html'),
    ui: {
        close: '.btn-close'
    },
    triggers: {
        'click @ui.close': 'close'
    },
    onClose(){
        this.modal.close();
    },
    initialize(){
        this.processing = true;
    },
    templateHelpers(){
        return {
            processing: this.processing
        };
    }
});


const CreateContactGroup = BindedView.extend({
  template: require('base/templates/contacts/new_group.html'),
  ui: {
      closeButton: '.button-close',
      form: 'form',
      type: '.group-type',
      name: '.group-name',
  },
  triggers: {
      'click @ui.closeButton': 'close',
      'submit @ui.form': 'send'
  },
  
  bindings: {
      'value @ui.type': 'group_type',
      'value @ui.name': 'name',
  },
  
  onClose(){
      this.modal.close();
  },
  
  onSend(){
    this.modal.close();
    let view = new ProcessingView();
    DialogService.show(view);
    this.model.save().done(() => {
      view.processing = false;
      view.render();
    });
  },
  
  initialize(){
      this.model = new ContactGroup({}, {
          filter: this.getOption('filter')
      });
      this.model.set({
          group_type: 'other',
          name: ''
      });
  },

});

export default CreateContactGroup;



// WEBPACK FOOTER //
// ./base/views/create_group.js